import React from "react";
import { PageTitle } from "./PageTitle";
import Loading from "../pages/common/Loading";

/**
 * UserList 기준 표준 리스트 페이지 레이아웃
 * - 페이지 타이틀만 border 밖 (버튼/기능 없음)
 * - 흰색 테두리 박스 안: 필터/액션 행 + 본문
 *
 * @param {string} title - 페이지 타이틀
 * @param {boolean} [loading] - 로딩 여부 (Loading 컴포넌트 표시)
 * @param {React.ReactNode} [filterContent] - 필터 영역 (왼쪽, select/input/필터 버튼 등)
 * @param {React.ReactNode} [actionButtons] - 액션 버튼 영역 (오른쪽, 예: 회원추가)
 * @param {React.ReactNode} [children] - 본문 (그리드 등)
 * @param {React.ReactNode} [icon] - PageTitle 아이콘 (Heroicons 컴포넌트)
 */
export function StandardListPage({
  title,
  loading = false,
  filterContent,
  actionButtons,
  children,
  icon,
}) {
  const hasToolbar = filterContent != null || actionButtons != null;

  return (
    <div className="flex flex-col h-full min-h-0">
      {loading ? <Loading /> : null}

      <div className="px-0 shrink-0">
        <PageTitle title={title} icon={icon} />
      </div>

      <div className="bg-white border border-gray-200 flex-1 min-h-0 flex flex-col overflow-hidden">
        {hasToolbar && (
          <div className="px-2 py-2 border-b border-gray-100 flex flex-wrap items-center justify-between gap-2 shrink-0">
            {filterContent != null ? (
              <div className="flex flex-wrap items-center gap-2">
                {filterContent}
              </div>
            ) : null}
            {actionButtons != null ? (
              <div className="shrink-0">{actionButtons}</div>
            ) : null}
          </div>
        )}

        {children != null ? (
          <div className="flex-1 min-h-0 flex flex-col overflow-hidden p-2">
            {children}
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default StandardListPage;
